import { render, staticRenderFns } from "./brandDetails.vue?vue&type=template&id=e8ef4bae&scoped=true"
import script from "./brandDetails.vue?vue&type=script&lang=js"
export * from "./brandDetails.vue?vue&type=script&lang=js"
import style0 from "./brandDetails.vue?vue&type=style&index=0&id=e8ef4bae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8ef4bae",
  null
  
)

export default component.exports